import { HttpClient, HttpEvent, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AlertOption } from '../interfaces';
import { BehaviorSubject, Observable } from '../models';
import { HttpService } from './http.service';

@Injectable()
export class CommonService {

  private _messageOptions: BehaviorSubject<AlertOption> = new BehaviorSubject<AlertOption>(null);
  private _apiLocalFile = '/api/LocalFile';

  constructor(
    private http: HttpClient,
    private httpService: HttpService
  ) { }

  alertMessage(option: AlertOption) {
    this._messageOptions.next(option);
  }

  get alert(): Observable<AlertOption> {
    return this._messageOptions.asObservable();
  }

  search(data: any[], f): any[] {
    if (!f) {
      return data;
    }
    const controls = Object.keys(f).filter(control => f[control]);
    if (controls.length && data.length) {
      return data.filter(r => {
        return controls.every(control =>
          control === 'name' ? String(r['firstName'] + ' ' + r['lastName']).toLowerCase().includes(String(f['name']).toLowerCase())
            : !isNaN(f[control].toString()) ? +r[control] === +f[control]
              : !!new Date(r[control]).getTime() ? new Date(r[control]).toDateString() === new Date(f[control]).toDateString()
                : control === 'genderText' ? String(r[control]).toLowerCase() === String(f[control]).toLowerCase()
                  : String(r[control]).toLowerCase().includes(String(f[control]).toLowerCase())
          // : f[control] = 'totalSent' && f[control].totalSent > 0 ? +r[control] >= +f[control]
        );
      });
    } else {
      return data;
    }
  }

  searchForAssociation(data: any[], f): any[] {
    if (!f) {
      return data;
    }
    const controls = Object.keys(f).filter(control => f[control]);
    if (controls.length) {
      return data.filter(r => {
        return controls.every(control =>
          control === 'name' ? String(r['firstName'] + ' ' + r['lastName']).toLowerCase().includes(String(f['name']).toLowerCase()) :
            control === 'teamName' ? String(r[control]).toLowerCase() == (String(f['teamName']).toLowerCase())
              : !isNaN(f[control].toString()) ? +r[control] === +f[control]
                : !!new Date(r[control]).getTime() ? new Date(r[control]).toDateString() === new Date(f[control]).toDateString()
                  : String(r[control]).toLowerCase().includes(String(f[control]).toLowerCase())
          // : f[control] = 'totalSent' && f[control].totalSent > 0 ? +r[control] >= +f[control]
        );
      });
    } else {
      return data;
    }
  }

  deleteFile(file: string) {
    return this.httpService.get(this._apiLocalFile + `/delete-file/${file}`);
  }

  downloadFile(file: string): Observable<HttpEvent<Blob>> {
    return this.http.request(new HttpRequest(
      'GET', `${this._apiLocalFile}/download-file/${file}`, null,
      {
        reportProgress: true,
        responseType: 'blob'
      }));
  }

}




// WEBPACK FOOTER //
// ./src/app/services/common.service.ts